import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import { useNavigate } from "react-router";
import { CreativeContext } from "./CreativeCreation";
import { SlProgressBar } from "@shoelace-style/shoelace/dist/react";

function BottomRectangle({
  company,
  companyName,
  handleshow,
  // advId,
  creative_name,
  creative_type,
  subtype,
  editdata,
  flag,
  handlesubmit,
  createdEdited,
}) {
  const navigate = useNavigate();
  console.log(subtype);
  const { preview, setPreview } = useContext(CreativeContext);
  const [progress, setProgress] = useState(0);
  const [inputFields, setInputFields] = useState([
    {
      img_id: "0",
      image: "",
    },
  ]);
  const [processingIndex, setProcessingIndex] = useState(-1);


  const imageChange = async (e, index) => {
    if (e.target.files && e.target.files.length > 0) {
      imageUrl(e.target.files[0], index);
      setProcessingIndex(index);
    } else {
      if (flag === "edit") {
        if (editdata.gallery[index]) {
          const values = [...inputFields];
          values[index].image = editdata.gallery[index].image;
          setInputFields(values);
          const { gallery } = preview;
          gallery[index] = editdata.gallery[index]?.image;
          setPreview({ ...preview, gallery: gallery });
        } else {
          setProgress(0);
          setValue(`image${index}`, "");
          const values = [...inputFields];
          values[index].image = "";
          setInputFields(values);
          const { gallery } = preview;
          gallery[index] = "";
          setPreview({ ...preview, gallery: gallery });
        }
      } else {
        setProgress(0);
        setValue(`image${index}`, "");
        const values = [...inputFields];
        values[index].image = "";
        setInputFields(values);
        const { gallery } = preview;
        gallery[index] = "";
        setPreview({ ...preview, gallery: gallery });
      }
    }
  };

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({ mode: "onSubmit" });
  const imageUrl = async (imgFile, index) => {
    try {
      const formData = new FormData();
      formData.append("files", imgFile);
      let url = await api({
        url: `/upload/brandImageExpandable`,
        method: "POST",
        responseType: "json",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (data) => {
          setProgress(Math.round((100 * data.loaded) / data.total));
        },
      });
      if (url.code === 200) {
        let values = [...inputFields];
        values[index].image = url.data.data;
        setInputFields(values);
        const { gallery } = preview;
        gallery[index].image = url.data.data;
        values[index].img_id = `${index}`;
        setPreview({ ...preview, gallery: gallery });
      } else {
        setProgress(0);
        setValue(`image${index}`, "");
        Toast("error", url.data.message);
      }
    } catch (error) {
      Toast("error", error);
    }
  };

  useEffect(() => {
    if (flag === "edit") {
        let gallery = JSON.parse(JSON.stringify(editdata.gallery));
        setInputFields(gallery);
      setPreview({
        ...preview,
        sub_type: editdata.sub_type,
        gallery: gallery,
      });
    }
    else{
        setPreview({
          ...preview,
          sub_type: subtype,
          gallery: inputFields,
        });
    }
  }, [company]);
  const handleAdd = () => {
    if (inputFields.length < 4) {
      setInputFields([
        ...inputFields,
        {
          image: "",
        },
      ]);
      const { gallery } = preview;
      gallery.push({image:""});
    } else {
      Toast("error", "Maximum limit of 4 Images exceeded");
    }
  };
  const handleRemove = (index) => {
    setValue(`image${index}`, "");
    const values = [...inputFields];
    values.splice(index, 1);
    if (editdata.gallery && editdata.gallery[index]) {
      editdata.gallery.splice(index, 1);
    }
    setInputFields(values);
    const { gallery } = preview;
    gallery.splice(index, 1);
    setPreview({ ...preview, gallery: gallery });
  };
  const onSubmit = async (data) => {
    if (inputFields.length < 2) {
      Toast("error", "Please add atleast 2 images");
      return;
    }
    if (flag === "add") {
      handlesubmit(true);
      let obj = {
        company_id: company,
        company_name: companyName,
        // adv_id: advId,
        creative_name,
        creative_type,
        sub_type: subtype,
        gallery: inputFields,
        clickurl: data.clickurl,
        impurl: { primary: data.impurl, secondary: data.impurl1 },
      };
      // if (advId !== "" && creative_name !== "") {
      if (creative_name !== "") {
        try {
          let res = await api({
            url: `/creatives/brandad/bottom-rectangle`,
            method: "POST",
            responseType: "json",
            data: obj,
          });
          if (res?.code === 200) {
            Toast("success", " Creative Created Successfully  ");
            handleshow(false);
            createdEdited(true);
          } else {
            Toast("error", res.data.message);
          }
        } catch (error) {
          console.error(error);
          if (error.response.status === 401) navigate("/");
        }
      }
    } else if (flag === "edit") {
      let obj = {
        creative_id: editdata.creative_id,
        creative_name: creative_name,
        gallery: inputFields,
        clickurl: data.clickurl,
        impurl: { primary: data.impurl, secondary: data.impurl1 },
      };
      try {
        let res = await api({
          url: `/creatives/brandad/edit-bottom-rectangle`,
          method: "POST",
          responseType: "json",
          data: obj,
        });
        if (res?.code === 200) {
          Toast("success", " Creative Edited Successfully  ");
          handleshow(false);
          createdEdited(true);
        } else {
          Toast("error", res.data.message);
        }
      } catch (error) {
        console.error(error);
        if (error.response.status === 401) navigate("/");
      }
    }
  };

  return (
    <>
      <div className="row">
        <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
          <div className="row">
            <section className="col-12">
              <div>
                <div>
                  {inputFields?.map((inputField, index) => (
                    <>
                      <label className="form-label" key={`label${index}`}>
                        Image
                      </label>
                      <br />
                      <span>(Image width should be greater than height )</span>
                      <div className="input-group mb-3" key={`img${index}`}>
                        <input
                          className="form-control "
                          type="file"
                          id="formFile"
                          name="files"
                          {...register(`image${index}`, {
                            required:
                              inputFields[index].image !== "" ? false : true,
                            onChange: (e) => imageChange(e, index),
                          })}
                        />
                        <div className="input-group-append">
                          <button
                            type="button"
                            className="btn btn-outline-danger"
                            onClick={() => handleRemove(index)}
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                      {errors[`image${index}`] && (
                        <p className="text-red-600">Image is mandatory</p>
                      )}
                      {processingIndex === index &&
                      progress > 0 &&
                      progress < 100 ? (
                        <SlProgressBar value={progress}>
                          {progress}%
                        </SlProgressBar>
                      ) : inputFields[index].image !== "" ? (
                        <span>{`${inputField.image}`}</span>
                      ) : (
                        flag === "edit" && <span>{`${inputField.image}`}</span>
                      )}
                      <br></br>
                    </>
                  ))}
                </div>
                <div className="flex justify-end">
                  <button
                    type="button"
                    name="add"
                    className="btn btn-primary"
                    onClick={() => handleAdd()}
                  >
                    Add
                  </button>
                </div>
              </div>

              <div className="row mb-3">
                <div className="col">
                  <label className="form-label">
                    Click URL / Mobile Number
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={editdata.click_url}
                    name="clickurl"
                    {...register("clickurl", {
                      required: false,
                      pattern: {
                        value:
                          /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)|^(0\d{10}|[6-9]\d{9})$/,
                        message: "Enter a Valid URL or Mobile Number",
                      },
                    })}
                  />
                  {errors.clickurl && (
                    <p className="text-red-600">{errors.clickurl.message}</p>
                  )}
                </div>
                <div className="col">
                  <label className="form-label">Impression URL - Primary</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={
                      editdata.impression_tracking_url
                        ? editdata.impression_tracking_url.primary
                        : null
                    }
                    {...register("impurl", {
                      required: false,
                      pattern: {
                        value:
                          /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                        message: "Enter a Valid URL",
                      },
                    })}
                  />
                  {errors.impurl && (
                    <p className="text-red-600">{errors.impurl.message}</p>
                  )}
                </div>
                <div className="col">
                  <label className="form-label">
                    Impression URL - Secondary
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={
                      editdata.impression_tracking_url
                        ? editdata.impression_tracking_url.secondary
                        : null
                    }
                    {...register("impurl1", {
                      required: false,
                      pattern: {
                        value:
                          /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                        message: "Enter a Valid URL",
                      },
                    })}
                  />
                  {errors.impurl1 && (
                    <p className="text-red-600">{errors.impurl1.message}</p>
                  )}
                </div>
              </div>
              <div className="my-3 text-end">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={progress > 0 && progress < 100 ? true : false}
                >
                  Save Creative
                </button>
              </div>
            </section>
          </div>
        </form>
      </div>
    </>
  );
}

export default BottomRectangle;
